import { useDispatch } from 'react-redux';

import { SelectedFare } from '../../../../../DesktopFlight/types';
import { addSelectedFlight } from '@entities/exchange';

export function useSelectFlight() {
	const dispatch = useDispatch();

	const onSelectExchangeFlight = (fare: SelectedFare) => {
		const flightId = fare.flightInfo?.id ?? fare.prices?.[0]?.flight?.id;

		dispatch(addSelectedFlight({ groupId: fare.fareGroupId, priceId: flightId }));
	};

	return {
		onSelectExchangeFlight
	};
}
